/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import { UnitTypeAuditsHead } from './tablehead';

import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';

const UnitTypeAuditTab = (props) => {
  const dispatch = useDispatch();
  const { gridData, frameworkComponents, handleFullScreen } = props;
  const [unitFullScreen, setUnitFullScreen] = React.useState(false);
  return (
    <div className="mt-3" style={{ height: 'auto' }}>
      <TableGrid
        data-testid="intcalc"
        rowData={gridData || []}
        gridHeight={unitFullScreen ? '70vh' : 360}
        handleFullScreenViewClick={() => {
          setUnitFullScreen(!unitFullScreen);
          handleFullScreen(!unitFullScreen);
        }}
        fullScreenView={unitFullScreen}
        columnDefs={UnitTypeAuditsHead}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        exportFile
        fileName="Unit Type Audits"
        onCellFocused={onCellFocused}
        frameworkComponents={frameworkComponents}
      />
      <div className="clearfix" />
    </div>
  );
};

export default UnitTypeAuditTab;
